/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGreaterThan = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 19v2H8v-2zM9.739 2 16 9l-6.261 7L8 14.65 13.054 9 8 3.35z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGreaterThan as GreaterThan };
